export default {
  namespaced: true,
  state: {
    modelThumbnailStatus: false,
    modelSkyboxStatus: false,
    modelEnvironmentStatus: false,
    modelSkyboxHeightStatus: false,
    modelCameraOrbitStatus: false,
    modelCameraTargetStatus: false,
  },
  mutations: {
    setModelThumbnailStatus(state, payload) {
      state.modelThumbnailStatus = payload;
    },
    setModelSkyboxStatus(state, payload) {
      state.modelSkyboxStatus = payload;
    },
    setModelEnvironmentStatus(state, payload) {
      state.modelEnvironmentStatus = payload;
    },
    setModelSkyboxHeightStatus(state, payload) {
      state.modelSkyboxHeightStatus = payload;
    },
    setModelCameraOrbitStatus(state, payload) {
      state.modelCameraOrbitStatus = payload;
    },
    setModelCameraTargetStatus(state, payload) {
      state.modelCameraTargetStatus = payload;
    },
  },
  actions: {
    setModelThumbnailStatus({ commit }, value) {
      commit("setModelThumbnailStatus", value);
    },
    setModelSkyboxStatus({ commit }, value) {
      commit("setModelSkyboxStatus", value);
    },
    setModelEnvironmentStatus({ commit }, value) {
      commit("setModelEnvironmentStatus", value);
    },
    setModelSkyboxHeightStatus({ commit }, value) {
      commit("setModelSkyboxHeightStatus", value);
    },
    setModelCameraOrbitStatus({ commit }, value) {
      commit("setModelCameraOrbitStatus", value);
    },
    setModelCameraTargetStatus({ commit }, value) {
      commit("setModelCameraTargetStatus", value);
    },
  },
  getters: {
    modelThumbnailStatus: (state) => state.modelThumbnailStatus,
    modelSkyboxStatus: (state) => state.modelSkyboxStatus,
    modelEnvironmentStatus: (state) => state.modelEnvironmentStatus,
    modelSkyboxHeightStatus: (state) => state.modelSkyboxHeightStatus,
    modelCameraOrbitStatus: (state) => state.modelCameraOrbitStatus,
    modelCameraTargetStatus: (state) => state.modelCameraTargetStatus,
  },
};
